import { CardDetails } from "@/models/CardDetails";
import PayChoiceTokenizeApi from "./PayChoiceTokenizeApi";
import PaymentSource from "@/models/APIModels/PaymentSource";
import BankDetails from "@/models/BankDetails";

export default interface IPaymentTokenizeApi {
  tokenizeCard(
    cardDetails: CardDetails,
    userCategory: string
  ): Promise<PaymentSource>;
  tokenizeBankDetails(bankDetails: BankDetails): Promise<PaymentSource>;
}

export const getPaymentTokenizer = (
  userCategory: string
): IPaymentTokenizeApi => new PayChoiceTokenizeApi(userCategory);
